import React from 'react'
import "./telecomPerformance.scss"

function TelecomPerformance() {
  return (
    <div className='container-telecom-performance'>
        <h1>TELECOM</h1>
    </div>
  )
}

export default TelecomPerformance